let TenderAnalytics;

const getComponentAsync = async store => {
  const { injectReducer } = await import("../../../store/reducers");

  TenderAnalytics = TenderAnalytics || (await import("../../Tender")).default;
  injectReducer(store, {
    key: "comments",
    reducer: (await import("@tenderplan3/store/modules/comments")).default
  });

  return TenderAnalytics;
};

export default store => ({
  path: "tender/:tender",
  getComponent(nextState, cb) {
    getComponentAsync(store).then(component => {
      cb(null, component);
    });
  }
});
